import React, { Component } from 'react'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import AuthenticationService from '../general/AuthenticationService.js'

const T = {
    bg:'#f1f5f9', card:'#ffffff', border:'#e8edf5',
    blue:'#3b82f6', blueD:'#2563eb', navy:'#0f172a',
    txt:'#1e293b', txt2:'#64748b', muted:'#94a3b8',
    green:'#16a34a', greenBg:'#f0fdf4', greenBdr:'#bbf7d0',
    red:'#dc2626', redBg:'#fef2f2', redBdr:'#fecaca',
    r:16, rsm:10,
    shadow:'0 1px 3px rgba(15,23,42,.06)',
    font:"'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
}

const authoritiesArray = [
    'READ_SOCIEDADES','WRITE_SOCIEDADES','DELETE_SOCIEDADES',
    'READ_CLIENTES','WRITE_CLIENTES','DELETE_CLIENTES',
    'READ_DOMICILIOS','WRITE_DOMICILIOS','DELETE_DOMICILIOS','SUPERVISOR_DOMICILIOS',
    'READ_PERSONAS_FISICAS','WRITE_PERSONAS_FISICAS','DELETE_PERSONAS_FISICAS',
    'READ_DOCUMENTOS','WRITE_DOCUMENTOS','DELETE_DOCUMENTOS',
    'READ_CFDIS','WRITE_CFDIS',
    'READ_USUARIOS','WRITE_USUARIOS','DELETE_USUARIOS',
    'READ_HISTORIA','READ_ALERTAS','READ_BUSQUEDA','READ_CONTABILIDAD',
]

const rolesArray = ['ADMIN','USUARIO LEGAL','USUARIO DOMICILIOS','SUPERVISOR DOMICILIOS','USUARIO CONTABLE','AUXILIAR CONTABLE','NINGUNO']

const rolePermissions = {
    'ADMIN': authoritiesArray,
    'USUARIO LEGAL': ['READ_SOCIEDADES','WRITE_SOCIEDADES','READ_CLIENTES','READ_DOMICILIOS','READ_PERSONAS_FISICAS','WRITE_PERSONAS_FISICAS','DELETE_PERSONAS_FISICAS','READ_DOCUMENTOS','WRITE_DOCUMENTOS','DELETE_DOCUMENTOS','READ_HISTORIA','READ_ALERTAS','READ_BUSQUEDA'],
    'USUARIO DOMICILIOS': ['READ_SOCIEDADES','READ_CLIENTES','READ_DOMICILIOS','WRITE_DOMICILIOS','READ_PERSONAS_FISICAS','READ_DOCUMENTOS','WRITE_DOCUMENTOS','DELETE_DOCUMENTOS','READ_HISTORIA','READ_ALERTAS','READ_BUSQUEDA'],
    'SUPERVISOR DOMICILIOS': ['READ_SOCIEDADES','READ_CLIENTES','READ_DOMICILIOS','WRITE_DOMICILIOS','DELETE_DOMICILIOS','SUPERVISOR_DOMICILIOS','READ_PERSONAS_FISICAS','READ_DOCUMENTOS','WRITE_DOCUMENTOS','DELETE_DOCUMENTOS','READ_HISTORIA','READ_ALERTAS','READ_BUSQUEDA'],
    'USUARIO CONTABLE': ['READ_SOCIEDADES','READ_CLIENTES','READ_DOMICILIOS','READ_PERSONAS_FISICAS','READ_DOCUMENTOS','READ_CFDIS','WRITE_CFDIS','READ_HISTORIA','READ_ALERTAS','READ_BUSQUEDA','READ_CONTABILIDAD'],
    'AUXILIAR CONTABLE': ['READ_CFDIS','WRITE_CFDIS'],
    'NINGUNO': [],
}

const permissionGroups = [
    { label:'Sociedades',      perms:['READ_SOCIEDADES','WRITE_SOCIEDADES','DELETE_SOCIEDADES'] },
    { label:'Clientes',        perms:['READ_CLIENTES','WRITE_CLIENTES','DELETE_CLIENTES'] },
    { label:'Domicilios',      perms:['READ_DOMICILIOS','WRITE_DOMICILIOS','DELETE_DOMICILIOS','SUPERVISOR_DOMICILIOS'] },
    { label:'Personas Físicas',perms:['READ_PERSONAS_FISICAS','WRITE_PERSONAS_FISICAS','DELETE_PERSONAS_FISICAS'] },
    { label:'Documentos',      perms:['READ_DOCUMENTOS','WRITE_DOCUMENTOS','DELETE_DOCUMENTOS'] },
    { label:'CFDIs',           perms:['READ_CFDIS','WRITE_CFDIS'] },
    { label:'Usuarios',        perms:['READ_USUARIOS','WRITE_USUARIOS','DELETE_USUARIOS'] },
    { label:'Otros',           perms:['READ_HISTORIA','READ_ALERTAS','READ_BUSQUEDA','READ_CONTABILIDAD'] },
]

const permLabel = p => {
    const full = {
        READ_SOCIEDADES:        'Ver',
        WRITE_SOCIEDADES:       'Crear / Editar',
        DELETE_SOCIEDADES:      'Eliminar',
        READ_CLIENTES:          'Ver',
        WRITE_CLIENTES:         'Crear / Editar',
        DELETE_CLIENTES:        'Eliminar',
        READ_DOMICILIOS:        'Ver',
        WRITE_DOMICILIOS:       'Crear / Editar',
        DELETE_DOMICILIOS:      'Eliminar',
        SUPERVISOR_DOMICILIOS:  'Supervisor',
        READ_PERSONAS_FISICAS:  'Ver',
        WRITE_PERSONAS_FISICAS: 'Crear / Editar',
        DELETE_PERSONAS_FISICAS:'Eliminar',
        READ_DOCUMENTOS:        'Ver',
        WRITE_DOCUMENTOS:       'Crear / Editar',
        DELETE_DOCUMENTOS:      'Eliminar',
        READ_CFDIS:             'Ver',
        WRITE_CFDIS:            'Crear / Editar',
        READ_USUARIOS:          'Ver',
        WRITE_USUARIOS:         'Crear / Editar',
        DELETE_USUARIOS:        'Eliminar',
        READ_HISTORIA:          'Ver Historial',
        READ_ALERTAS:           'Ver Alertas',
        READ_BUSQUEDA:          'Búsqueda General',
        READ_CONTABILIDAD:      'Ver Contabilidad',
    }
    return full[p] || p
}

const GROUP_COLORS = [
    T.blue, '#7c3aed', '#0891b2', '#ea580c',
    '#a21caf', T.green, T.red, '#64748b',
]

class UserFormularioComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            edit: false,
            userName: '',
            originalUserName: '',  // nombre original al cargar en modo edición
            password1: '',
            password2: '',
            authorities: [],
            showPass1: false,
            showPass2: false,
            saving: false,
            errors: [],
        }
        this.onSubmit      = this.onSubmit.bind(this)
        this.addAuthority  = this.addAuthority.bind(this)
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization('WRITE_USUARIOS')) {
            this.props.history.push('/login'); return
        }
        const { match: { params } } = this.props

        // Modo clonar: nuevo usuario heredando permisos de otro
        const query = new URLSearchParams(this.props.location.search)
        const cloneFrom = query.get('clone')
        if (cloneFrom) {
            ElementsDataService.retrieveElement('users', cloneFrom)
                .then(r => this.setState({
                    authorities: r.data.authoritiesValues || [],
                }))
            return
        }

        if (Number(params.id) === -1) return
        ElementsDataService.retrieveElement('users', params.id)
            .then(r => this.setState({
                userName:         r.data.userName,
                originalUserName: r.data.userName,
                edit:             true,
                authorities:      r.data.authoritiesValues || [],
            }))
    }

    validate() {
        const { userName, edit, password1, password2 } = this.state
        const errors = []
        if (!userName.trim()) errors.push('Introduce un nombre de usuario')
        if (userName.trim().length < 5) errors.push('El nombre de usuario debe tener al menos 5 caracteres')
        if (!edit && !password1) errors.push('La contraseña es obligatoria')
        if (password1 && password1.length < 8) errors.push('La contraseña debe tener al menos 8 caracteres')
        if (password1 !== password2) errors.push('Las contraseñas no coinciden')
        return errors
    }

    onSubmit() {
        const errors = this.validate()
        if (errors.length) { this.setState({ errors }); return }
        this.setState({ saving: true, errors: [] })

        const { edit, userName, originalUserName, password1, authorities } = this.state
        const isRenaming = edit && userName.trim() !== originalUserName

        const payload = {
            userName:         originalUserName || userName,  // nombre actual (ID para el backend)
            newUserName:      isRenaming ? userName.trim() : undefined,  // nuevo nombre solo si cambió
            password:         password1 || undefined,
            authoritiesValues: authorities,
        }

        const action = !edit
            ? ElementsDataService.createElement('users', payload)
            : ElementsDataService.updateElement('users', originalUserName, payload)

        action
            .then(() => this.props.history.push('/users'))
            .catch(err => {
                const msg = err?.response?.data || 'Error al guardar usuario'
                this.setState({ saving: false, errors: [msg] })
            })
    }

    addAuthority(checked, authority) {
        let a = [...this.state.authorities]
        if (checked) { if (!a.includes(authority)) a.push(authority) }
        else { a = a.filter(x => x !== authority) }
        this.setState({ authorities: a })
    }

    render() {
        const { edit, userName, originalUserName, password1, password2, authorities, showPass1, showPass2, saving, errors } = this.state

        const inputStyle = (focused) => ({
            width:'100%', padding:'10px 14px', borderRadius:T.rsm, fontFamily:T.font,
            border:`1px solid ${focused ? T.blue : T.border}`, fontSize:14, color:T.txt,
            background:T.card, outline:'none', boxSizing:'border-box',
            boxShadow: focused ? `0 0 0 3px ${T.blue}20` : T.shadow, transition:'all .15s',
        })

        const labelStyle = {
            display:'block', fontSize:11, fontWeight:600, color:T.txt2,
            marginBottom:5, textTransform:'uppercase', letterSpacing:'.05em',
        }

        return (
            <div style={{ minHeight:'100vh', background:T.bg, fontFamily:T.font, padding:'24px 28px 64px' }}>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                    @keyframes spin { to { transform:rotate(360deg) } }
                    input[type=checkbox] { accent-color: ${T.blue}; width:16px; height:16px; cursor:pointer; }
                `}</style>

                <div style={{ maxWidth:860, margin:'0 auto' }}>

                    {/* ── Header ── */}
                    <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:24 }}>
                        <button onClick={() => this.props.history.goBack()}
                            style={{ width:34, height:34, borderRadius:9, border:`1px solid ${T.border}`,
                                background:T.card, cursor:'pointer', fontSize:16, color:T.txt2,
                                display:'flex', alignItems:'center', justifyContent:'center',
                                boxShadow:T.shadow, flexShrink:0, fontFamily:T.font, transition:'all .15s' }}
                            onMouseEnter={e => { e.currentTarget.style.background=T.navy; e.currentTarget.style.color='white' }}
                            onMouseLeave={e => { e.currentTarget.style.background=T.card; e.currentTarget.style.color=T.txt2 }}>
                            ‹
                        </button>
                        <div>
                            <h1 style={{ margin:0, fontSize:22, fontWeight:800, color:T.navy, letterSpacing:'-0.025em' }}>
                                {edit ? `Editar Usuario` : 'Nuevo Usuario'}
                            </h1>
                            <p style={{ margin:'3px 0 0', fontSize:13, color:T.txt2 }}>
                                {edit
                                    ? `Modificando permisos y contraseña de ${userName}`
                                    : new URLSearchParams(window.location.search).get('clone')
                                        ? `Nuevo usuario — permisos copiados de ${new URLSearchParams(window.location.search).get('clone')}`
                                        : 'Completa los datos para crear un nuevo usuario'}
                            </p>
                        </div>
                    </div>

                    {/* ── Errores ── */}
                    {errors.length > 0 && (
                        <div style={{ marginBottom:16, padding:'12px 16px', borderRadius:T.rsm,
                            background:T.redBg, border:`1px solid ${T.redBdr}` }}>
                            {errors.map((e, i) => (
                                <div key={i} style={{ fontSize:13, color:T.red, fontWeight:600,
                                    display:'flex', alignItems:'center', gap:8 }}>
                                    ⚠️ {e}
                                </div>
                            ))}
                        </div>
                    )}

                    {/* ── Sección: Datos de acceso ── */}
                    <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:T.r,
                        boxShadow:T.shadow, padding:'20px 24px', marginBottom:16 }}>
                        <p style={{ margin:'0 0 16px', fontSize:11, fontWeight:700, color:T.muted,
                            textTransform:'uppercase', letterSpacing:'.08em' }}>Datos de acceso</p>

                        {/* Username */}
                        <div style={{ marginBottom:16 }}>
                            <label style={labelStyle}>
                                Nombre de Usuario
                                {edit && userName !== originalUserName && (
                                    <span style={{ marginLeft:8, fontSize:10, fontWeight:700,
                                        color:'#f59e0b', background:'#fffbeb',
                                        border:'1px solid #fde68a', borderRadius:4,
                                        padding:'1px 7px', letterSpacing:'.04em' }}>
                                        RENOMBRANDO
                                    </span>
                                )}
                            </label>
                            <input autoComplete="off" value={userName}
                                onChange={e => this.setState({ userName: e.target.value })}
                                placeholder="Ej. juan.perez"
                                style={{
                                    ...inputStyle(false),
                                    borderColor: edit && userName !== originalUserName ? '#f59e0b' : T.border,
                                    boxShadow:   edit && userName !== originalUserName ? '0 0 0 3px #f59e0b20' : T.shadow,
                                }}
                                onFocus={e => Object.assign(e.target.style, { borderColor:T.blue, boxShadow:`0 0 0 3px ${T.blue}20` })}
                                onBlur={e => Object.assign(e.target.style, {
                                    borderColor: userName !== originalUserName ? '#f59e0b' : T.border,
                                    boxShadow:   userName !== originalUserName ? '0 0 0 3px #f59e0b20' : T.shadow,
                                })} />
                            {edit && userName !== originalUserName && (
                                <p style={{ margin:'5px 0 0', fontSize:11, color:'#92400e',
                                    background:'#fffbeb', border:'1px solid #fde68a',
                                    borderRadius:6, padding:'5px 10px', display:'flex',
                                    alignItems:'center', gap:6 }}>
                                    ⚠️ Se renombrará <strong>{originalUserName}</strong> → <strong>{userName}</strong>.
                                    El usuario deberá iniciar sesión con el nuevo nombre.
                                </p>
                            )}
                        </div>

                        {/* Passwords */}
                        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
                            <div>
                                <label style={labelStyle}>{edit ? 'Nueva contraseña (opcional)' : 'Contraseña *'}</label>
                                <div style={{ position:'relative' }}>
                                    <input autoComplete="new-password" value={password1}
                                        type={showPass1 ? 'text' : 'password'}
                                        onChange={e => this.setState({ password1: e.target.value })}
                                        style={{ ...inputStyle(false), paddingRight:40 }}
                                        onFocus={e => Object.assign(e.target.style, { borderColor:T.blue, boxShadow:`0 0 0 3px ${T.blue}20` })}
                                        onBlur={e => Object.assign(e.target.style, { borderColor:T.border, boxShadow:T.shadow })} />
                                    <button type="button" onClick={() => this.setState({ showPass1: !showPass1 })}
                                        style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)',
                                            background:'none', border:'none', cursor:'pointer', fontSize:16, color:T.muted }}>
                                        {showPass1
                                            ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                                            : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                        }
                                    </button>
                                </div>
                                <p style={{ margin:'4px 0 0', fontSize:11, color:T.muted }}>Mínimo 8 caracteres</p>
                            </div>
                            <div>
                                <label style={labelStyle}>Confirmar contraseña</label>
                                <div style={{ position:'relative' }}>
                                    <input autoComplete="new-password" value={password2}
                                        type={showPass2 ? 'text' : 'password'}
                                        onChange={e => this.setState({ password2: e.target.value })}
                                        style={{ ...inputStyle(false),
                                            paddingRight:40,
                                            borderColor: password2 && password1 !== password2 ? T.red : T.border }}
                                        onFocus={e => Object.assign(e.target.style, { borderColor:T.blue, boxShadow:`0 0 0 3px ${T.blue}20` })}
                                        onBlur={e => Object.assign(e.target.style, { borderColor: password2 && password1 !== password2 ? T.red : T.border, boxShadow:T.shadow })} />
                                    <button type="button" onClick={() => this.setState({ showPass2: !showPass2 })}
                                        style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)',
                                            background:'none', border:'none', cursor:'pointer', fontSize:16, color:T.muted }}>
                                        {showPass2
                                            ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                                            : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                        }
                                    </button>
                                </div>
                                {password2 && password1 !== password2 && (
                                    <p style={{ margin:'4px 0 0', fontSize:11, color:T.red, fontWeight:600 }}>Las contraseñas no coinciden</p>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* ── Sección: Rol predefinido ── */}
                    <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:T.r,
                        boxShadow:T.shadow, padding:'20px 24px', marginBottom:16 }}>
                        <p style={{ margin:'0 0 14px', fontSize:11, fontWeight:700, color:T.muted,
                            textTransform:'uppercase', letterSpacing:'.08em' }}>Rol predefinido</p>
                        <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                            {rolesArray.map(rol => {
                                const isActive = rolePermissions[rol]?.length > 0 &&
                                    rolePermissions[rol].every(p => authorities.includes(p)) &&
                                    authorities.length === rolePermissions[rol].length
                                return (
                                    <button key={rol} onClick={() => this.setState({ authorities: rolePermissions[rol] || [] })}
                                        style={{ padding:'7px 16px', borderRadius:20, fontSize:12, fontWeight:600,
                                            border:`1px solid ${isActive ? T.blue : T.border}`,
                                            background: isActive ? T.blue : T.card,
                                            color: isActive ? 'white' : T.txt2,
                                            cursor:'pointer', fontFamily:T.font, transition:'all .15s' }}>
                                        {rol}
                                    </button>
                                )
                            })}
                        </div>
                    </div>

                    {/* ── Sección: Permisos ── */}
                    <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:T.r,
                        boxShadow:T.shadow, padding:'20px 24px', marginBottom:20 }}>
                        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
                            <p style={{ margin:0, fontSize:11, fontWeight:700, color:T.muted,
                                textTransform:'uppercase', letterSpacing:'.08em' }}>Permisos individuales</p>
                            <div style={{ display:'flex', gap:8 }}>
                                <button onClick={() => this.setState({ authorities: [...authoritiesArray] })}
                                    style={{ padding:'5px 14px', borderRadius:T.rsm, border:`1px solid ${T.border}`,
                                        background:T.bg, color:T.txt2, fontSize:12, fontWeight:600,
                                        cursor:'pointer', fontFamily:T.font }}>
                                    Seleccionar todo
                                </button>
                                <button onClick={() => this.setState({ authorities: [] })}
                                    style={{ padding:'5px 14px', borderRadius:T.rsm, border:`1px solid ${T.border}`,
                                        background:T.bg, color:T.txt2, fontSize:12, fontWeight:600,
                                        cursor:'pointer', fontFamily:T.font }}>
                                    Limpiar todo
                                </button>
                            </div>
                        </div>

                        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(220px,1fr))', gap:12 }}>
                            {permissionGroups.map((group, gi) => {
                                const color   = GROUP_COLORS[gi % GROUP_COLORS.length]
                                const allOn   = group.perms.every(p => authorities.includes(p))
                                const someOn  = group.perms.some(p => authorities.includes(p))
                                return (
                                    <div key={group.label} style={{ background:T.bg,
                                        border:`1px solid ${someOn ? color+'40' : T.border}`,
                                        borderRadius:T.rsm, padding:'14px 16px',
                                        borderTop:`3px solid ${someOn ? color : T.border}` }}>
                                        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:10 }}>
                                            <span style={{ fontSize:12, fontWeight:700, color, textTransform:'uppercase', letterSpacing:'.04em' }}>
                                                {group.label}
                                            </span>
                                            {/* Toggle grupo completo */}
                                            <button onClick={() => {
                                                if (allOn) {
                                                    this.setState({ authorities: authorities.filter(a => !group.perms.includes(a)) })
                                                } else {
                                                    const merged = [...new Set([...authorities, ...group.perms])]
                                                    this.setState({ authorities: merged })
                                                }
                                            }} style={{ fontSize:10, padding:'2px 8px', borderRadius:8,
                                                border:`1px solid ${color}40`, background: allOn ? color : 'white',
                                                color: allOn ? 'white' : color, cursor:'pointer',
                                                fontFamily:T.font, fontWeight:700 }}>
                                                {allOn ? 'Quitar' : 'Todos'}
                                            </button>
                                        </div>
                                        {group.perms.map(perm => (
                                            <label key={perm} style={{ display:'flex', alignItems:'center',
                                                justifyContent:'space-between', padding:'5px 0',
                                                borderBottom:`1px solid ${T.border}`, cursor:'pointer' }}>
                                                <span style={{ fontSize:13, color: authorities.includes(perm) ? T.txt : T.txt2 }}>
                                                    {permLabel(perm)}
                                                </span>
                                                <input type="checkbox"
                                                    checked={authorities.includes(perm)}
                                                    onChange={e => this.addAuthority(e.target.checked, perm)} />
                                            </label>
                                        ))}
                                    </div>
                                )
                            })}
                        </div>

                        {/* Resumen de permisos activos */}
                        <div style={{ marginTop:14, padding:'10px 14px', borderRadius:T.rsm,
                            background:`${T.blue}08`, border:`1px solid ${T.blue}20`,
                            fontSize:12, color:T.blueD, fontWeight:600 }}>
                            {authorities.length} de {authoritiesArray.length} permisos activos
                        </div>
                    </div>

                    {/* ── Footer ── */}
                    <div style={{ display:'flex', justifyContent:'flex-end', gap:10 }}>
                        <button onClick={() => this.props.history.push('/users')}
                            style={{ padding:'10px 24px', borderRadius:T.rsm, border:`1px solid ${T.border}`,
                                background:T.card, color:T.txt2, fontSize:13, fontWeight:600,
                                cursor:'pointer', fontFamily:T.font }}>
                            Cancelar
                        </button>
                        <button onClick={this.onSubmit} disabled={saving}
                            style={{ padding:'10px 28px', borderRadius:T.rsm, border:'none',
                                background: saving ? T.muted : T.blue, color:'white',
                                fontSize:13, fontWeight:700, cursor: saving ? 'not-allowed':'pointer',
                                fontFamily:T.font, boxShadow: saving ? 'none' : `0 4px 12px ${T.blue}40`,
                                display:'inline-flex', alignItems:'center', gap:8 }}>
                            {saving ? (
                                <>
                                    <div style={{ width:14, height:14, border:'2px solid #ffffff40',
                                        borderTopColor:'white', borderRadius:'50%',
                                        animation:'spin .7s linear infinite' }} />
                                    Guardando...
                                </>
                            ) : '✓ Guardar Usuario'}
                        </button>
                    </div>

                </div>
            </div>
        )
    }
}

export default UserFormularioComponent
